export default "__VITE_ASSET__BxyoCDft__"